import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_8: FaireProductEntity = {
  token: "caden-lane-8",
  type: "product",
  name: "Large Cuddle Plush Friends | Honey Bunny",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/8473db7ded01dfe05b69170d27ced02b84b0ade97deda9a8602f3f8a35d7e486.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 22,
  msrpDollars: 44,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
